/**
 * Kill-switch dos tours guiados.
 *
 * Avaliado **na importação do módulo**, antes de qualquer renderização, e nunca
 * reavaliado. Isso é deliberado: um tour que decide se abre depois que a tela já
 * montou instala um overlay que passa a interceptar cliques no meio da sessão —
 * quem clicou antes passa, quem clicou depois falha. O sintoma parece
 * concorrência e o diagnóstico se perde por semanas.
 *
 * Três formas de desligar, da mais ampla para a mais local:
 *
 *   1. Build:      VITE_TOURS_ENABLED=false
 *   2. Sessão:     localStorage.setItem('gfi_tours_disabled', '1')
 *   3. Uma visita: ?tour=off na URL
 *
 * A forma 3 também grava a 2, para que testes automatizados desliguem uma vez e
 * o resto da navegação siga sem tour.
 */

const STORAGE_KEY = "gfi_tours_disabled";

function resolveEnabled(): boolean {
  // Fora do navegador (SSR, teste de nó) não há tour a exibir.
  if (typeof window === "undefined") return false;

  if (import.meta.env.VITE_TOURS_ENABLED === "false") return false;

  try {
    const url = new URL(window.location.href);
    if (url.searchParams.get("tour") === "off") {
      window.localStorage.setItem(STORAGE_KEY, "1");
      return false;
    }
    if (window.localStorage.getItem(STORAGE_KEY) === "1") return false;
  } catch {
    // localStorage bloqueado (modo privado, cookies negados). Sem forma de saber
    // a preferência, o padrão é não interromper a pessoa com um overlay.
    return false;
  }

  return true;
}

/** Congelado na carga do módulo — ver o comentário do topo. */
export const TOURS_ENABLED: boolean = resolveEnabled();

/** Desliga os tours a partir da próxima carga. Usado por Configurações. */
export function disableTours(): void {
  window.localStorage.setItem(STORAGE_KEY, "1");
}

/** Religa os tours a partir da próxima carga. */
export function enableTours(): void {
  window.localStorage.removeItem(STORAGE_KEY);
}
